export default ({ $axios, $toast }) => {
  if (typeof window === 'undefined') return

  const runtime = window.__TAJADAD_OC_CONFIG__ || {}
  if (runtime.apiBase) {
    $axios.setBaseURL(`${String(runtime.apiBase).replace(/\/+$/, '')}/`)
  }

  if ($toast && typeof $toast.error === 'function') {
    const showError = $toast.error.bind($toast)
    const recentErrors = new Map()
    const networkErrorPattern = /(Failed to fetch|NetworkError|Load failed|تعذر الاتصال ببيانات التطبيق)/i

    $toast.error = (message, options = {}) => {
      const rawMessage = String(message || '')
      const merchantMessage = networkErrorPattern.test(rawMessage)
        ? 'تعذر تحميل بيانات التطبيق. تحقق من اتصالك ثم أعد المحاولة.'
        : rawMessage
      const now = Date.now()
      const previous = recentErrors.get(merchantMessage) || 0

      if (now - previous < 5000) {
        return null
      }

      recentErrors.set(merchantMessage, now)
      window.setTimeout(() => recentErrors.delete(merchantMessage), 5500)

      return showError(merchantMessage, {
        ...options,
        position: 'top-center'
      })
    }
  }
}
